export function defaultFallbackAction(data: any, context: any) {
    alert(JSON.stringify({ data, context }, null, 4));
    return data;
}

export default defaultFallbackAction;
